import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="cancel-session"
export default class extends Controller {
  static targets = ["reasonField"];

  connect() {
    // Check if there's a checkbox and update the reason field visibility accordingly
    const checkbox = this.element.querySelector('input[type="checkbox"]');
    if (checkbox) {
      this.toggleReasonField(checkbox.checked);
    }
  }

  toggle(event) {
    this.toggleReasonField(event.target.checked);
  }

  toggleReasonField(checked) {
    if (checked) {
      this.reasonFieldTarget.classList.remove("hidden");
      const textarea = this.reasonFieldTarget.querySelector("textarea");
      if (textarea) {
        textarea.required = true;
      }
    } else {
      this.reasonFieldTarget.classList.add("hidden");
      const textarea = this.reasonFieldTarget.querySelector("textarea");
      if (textarea) {
        textarea.required = false;
        textarea.value = "";
      }
    }
  }
}
